const FieldTypeUtils = require('./fieldTypes');
const FormFieldUtils = require('./formFieldUtils');

const FormModelUtils = module.exports = {};

FormModelUtils.normalizeFields = (fields = []) => FormFieldUtils.flattenFields(fields)
    .map((field) => FormModelUtils.normalizeField(field));

FormModelUtils.normalizeField = (field = {}) => {

    const normalizedField = { ...field };
    const children = FormFieldUtils.getFieldChildren(field);

    if (children.length) {
        const normalizedChildren = FormModelUtils.normalizeFields(children);

        if (Array.isArray(field.fields)) {
            normalizedField.fields = normalizedChildren;
        }
    }

    if (Array.isArray(field.options)) {
        normalizedField.options = FormModelUtils.sortSpecifyOptions(field.options);
    }

    return normalizedField;
};

FormModelUtils.sortSpecifyOptions = (options = []) => options
    .map((option, index) => ({
        index,
        isSpecifyOption: FormModelUtils.isSpecifyOption(option),
        option
    }))
    .sort((a, b) => {

        if (a.isSpecifyOption !== b.isSpecifyOption) {
            return a.isSpecifyOption ? 1 : -1;
        }

        return a.index - b.index;
    })
    .map(({ option }) => option);

FormModelUtils.isSpecifyOption = (option) => {

    const optionText = FormModelUtils.getOptionSearchText(option);
    return optionText.includes('specif') && (optionText.includes('other') || optionText.includes('below'));
};

FormModelUtils.getOptionSearchText = (option) => {

    if (!option) {
        return '';
    }

    if (typeof option !== 'object') {
        return String(option).toLowerCase();
    }

    return [
        option.label,
        option.name,
        option.text,
        option.title,
        option.value
    ]
        .filter((value) => typeof value === 'string' || typeof value === 'number')
        .join(' ')
        .toLowerCase();
};

FormModelUtils.stringifyDefaults = (defaults) => {

    try {
        return JSON.stringify(defaults);
    }
    catch (err) {
        return String(defaults);
    }
};

FormModelUtils.areEquivalent = (a, b) => FormModelUtils.stringifyDefaults(a) === FormModelUtils.stringifyDefaults(b);

FormModelUtils.getFieldDefault = (field = {}) => {

    if (Object.prototype.hasOwnProperty.call(field, 'default')) {
        return field.default;
    }

    switch (FieldTypeUtils.normalizePrimitiveType(field.type)) {
        case 'CheckboxField':
            return false;
        case 'FileField':
            return null;
        case 'MultiSelectField':
            return [];
        default:
            return '';
    }
};

FormModelUtils.collectFieldDefaults = (collector, field = {}) => {

    if (Array.isArray(field)) {
        FormFieldUtils.flattenFields(field)
            .forEach((item) => FormModelUtils.collectFieldDefaults(collector, item));
        return collector;
    }

    const children = FormFieldUtils.getFieldChildren(field);

    if (children.length) {
        FormFieldUtils.flattenFields(children)
            .forEach((item) => FormModelUtils.collectFieldDefaults(collector, item));
        return collector;
    }

    if (!field.name || typeof collector[field.name] !== 'undefined') {
        return collector;
    }

    collector[field.name] = FormModelUtils.getFieldDefault(field);
    return collector;
};

FormModelUtils.buildDefaults = ({
    defaults = {},
    fields = []
} = {}) => FormModelUtils.normalizeFields(fields).reduce(
    FormModelUtils.collectFieldDefaults,
    { ...defaults }
);

FormModelUtils.compactFields = (...fields) => FormModelUtils.normalizeFields(fields);
